// Mock implementation of Catalyst SDK for local development
class MockCatalyst {
    constructor() {
        this.userManagement = {
            getCurrentProjectUser: () => {
                return Promise.resolve({
                    content: {
                        first_name: "Local",
                        last_name: "Developer",
                        email_id: "developer@local.test",
                        role_details: {
                            role_name: "Admin",
                            role_id: "30083000000008090"
                        }
                    }
                });
            }
        };
        this.auth = {
            isUserAuthenticated: () => {
                return true;
            }
        };
    }
}

// Expose a global catalyst object that matches the expected interface
if (!window.catalyst) {
    console.warn("Catalyst SDK not found. Using mock SDK for local development");
    window.catalyst = new MockCatalyst();
}

export default window.catalyst;
